module.exports = __webpack_public_path__ + "img/地榆.8509cca2.jpg";